var SwitchSize = /*#__PURE__*/ function(SwitchSize) {
    SwitchSize["Medium"] = "medium";
    SwitchSize["Small"] = "small";
    return SwitchSize;
}({});
var SwitchVariant = /*#__PURE__*/ function(SwitchVariant) {
    SwitchVariant["Immediate"] = "immediate";
    SwitchVariant["Standard"] = "standard";
    return SwitchVariant;
}({});

export { SwitchSize, SwitchVariant };
//# sourceMappingURL=switch.js.map
